import { Action } from "../../shell/Actions/Action";
import Character from "../../shell/Character";
import Game from "../../shell/Game";
import { setAdvance } from "../../store/slices/AdvanceSlice";
import { setLastUpdated } from "../../store/slices/gameObjectSlice";
import { GameNames } from "../../store/slices/GameTypes";
import { InstaProfilesSlice, setDisplay, setInsta, TInstaINT } from "../../store/slices/instaSlice";
import { store } from "../../store/store";
import { RollbackType } from "../Tadvance";
import { InstaProfileINT } from "./interfaces";

export class Insta {
    // static images: InstaImage[] = instaImages.map(image => (image.url as any)?.default ? { url: (image.url as any).default } : { url: image.url });
    static instaProfiles: InstaProfilesSlice;
    constructor() {
    }

    static open(profiles: InstaProfilesSlice) {

        const _data = <TInstaINT>{ display: true, profiles };

        return new Action(_data, GameNames.INSTA).run(
            function UI(callback: () => void) {
                // Insta.instaLogic();
                store.dispatch(setInsta(_data));
                if (!Game.rollback) {
                    store.dispatch(setLastUpdated({ updatedValue: GameNames.INSTA }));
                    store.dispatch(setDisplay({ display: true }));
                }
                callback();
            }
            , false);
    }
    static close() {
        // Game.Action?.promise(false);
        // const _data = { display: false } as TInstaINT;
        store.dispatch(setDisplay({ display: false }));
        store.dispatch(setAdvance({ canAdvance: true, promise: false }));

        // store.dispatch(lastUpdated(Game.Action?.next?.actionId || null));
    }
    private static _initialize = (() => {
        Object.defineProperty(Insta, "instaProfiles", {
            get: () => {
                return store.getState().insta.present.profiles || {};
            },

        });
    })();
}